import { defineMessages } from 'react-intl'

const messages = defineMessages({
  tableHeader: {
    id: 'customerSettings.customer.tableHeader',
    description: 'Customer table header',
    defaultMessage: 'Customers',
  },
  name: {
    id: 'customerSettings.customer.name',
    description: 'Customer Settings name',
    defaultMessage: 'Customer Name',
  },
  alias: {
    id: 'customerSettings.customer.alias',
    description: 'Customer Settings alias',
    defaultMessage: 'Alias',
  },
  accountNumber: {
    id: 'customerSettings.customer.accountNumber',
    description: 'Customer Settings accountNumber',
    defaultMessage: 'Account Number',
  },
  locationName: {
    id: 'customerSettings.customer.locationName',
    description: 'Customer Settings Location Name name',
    defaultMessage: 'Location Name',
  },
  address: {
    id: 'customerSettings.customer.address',
    description: 'Customer Settings address',
    defaultMessage: 'Address',
  },
  addressIsRequired: {
    id: 'customerSettings.customer.addressIsRequired',
    description: 'Address is required',
    defaultMessage: 'Address is required',
  },
  defaultCurrencyIsRequired: {
    id: 'customerSettings.customer.defaultCurrencyIsRequired',
    description: 'Default currency is required',
    defaultMessage: 'Default currency is required',
  },
  cityIsRequired: {
    id: 'customerSettings.customer.cityIsRequired',
    description: 'City is required',
    defaultMessage: 'City is required',
  },
  countryIsRequired: {
    id: 'customerSettings.customer.countryIsRequired',
    description: 'Country is required',
    defaultMessage: 'Country is required',
  },
  address1: {
    id: 'customerSettings.customer.address1',
    description: 'Customer Settings address1',
    defaultMessage: 'Address 1',
  },
  address1isRequired: {
    id: 'customerSettings.customer.address1isRequired',
    description: 'Customer Settings address1isRequired',
    defaultMessage: 'Address is required',
  },
  customerNameRequired: {
    id: 'customerSettings.customer.customerNameRequired',
    description: 'Customer Settings customerNameRequired',
    defaultMessage: 'Customer Name is required',
  },
  accountOwnerEmailRequired: {
    id: 'customerSettings.customer.accountOwnerEmailRequired',
    description: 'Customer Settings accountOwnerEmailRequired',
    defaultMessage: 'Account Manager Email is required',
  },
  address2: {
    id: 'customerSettings.customer.address2',
    description: 'Customer Settings address2',
    defaultMessage: 'Address 2',
  },
  address3: {
    id: 'customerSettings.customer.address3',
    description: 'Customer Settings address3',
    defaultMessage: 'Address 3',
  },
  city: {
    id: 'customerSettings.customer.city',
    description: 'Customer Settings city',
    defaultMessage: 'City',
  },
  state: {
    id: 'customerSettings.customer.state',
    description: 'Customer Settings state',
    defaultMessage: 'State',
  },
  postalCode: {
    id: 'customerSettings.customer.postalCode',
    description: 'Customer Settings postalCode',
    defaultMessage: 'Postal Code',
  },
  country: {
    id: 'customerSettings.customer.country',
    description: 'Customer Settings country',
    defaultMessage: 'Country',
  },
  defaultCurrency: {
    id: 'customerSettings.customer.defaultCurrency',
    description: 'Customer Settings defaultCurrency',
    defaultMessage: 'Default Currency',
  },
  enabled: {
    id: 'customerSettings.customer.enabled',
    description: 'Customer Settings enabled',
    defaultMessage: 'Enabled',
  },

  customerCreateSuccess: {
    id: 'customerSettings.customer.customerCreateSuccess',
    description: 'Customer Settings customerCreateSuccess',
    defaultMessage: 'Successfully created {customerName} customer',
  },
  customerCreateError: {
    id: 'customerSettings.customer.customerCreateError',
    description: 'Customer Settings customerCreateError',
    defaultMessage: 'Error creating {customerName} customer',
  },
  customerUpdateSuccess: {
    id: 'customerSettings.customer.customerUpdateSuccess',
    description: 'Customer Settings customerUpdateSuccess',
    defaultMessage: 'Successfully updated {customerName} customer',
  },
  customerUpdateError: {
    id: 'customerSettings.customer.customerUpdateError',
    description: 'Customer Settings customerUpdateError',
    defaultMessage: 'Error updating {customerName} customer',
  },
  customerDeleteSuccess: {
    id: 'customerSettings.customer.customerDeleteSuccess',
    description: 'Customer Settings customerDeleteSuccess',
    defaultMessage: 'Successfully deleted {customerName} customer',
  },
  customerDeleteError: {
    id: 'customerSettings.customer.customerDeleteError',
    description: 'Customer Settings customerDeleteError',
    defaultMessage: 'Error deleting {customerName} customer',
  },

  newCustomerCreated: {
    id: 'customerSettings.customer.newCustomerCreated',
    description: 'New customer created success message',
    defaultMessage: 'New Customer created',
  },
  customerRecordUpdated: {
    id: 'customerSettings.customer.customerRecordUpdated',
    description: 'Customer record updated success message',
    defaultMessage: 'Customer record updated',
  },
  customerCreateFailed: {
    id: 'customerSettings.customer.customerCreateFailed',
    description: 'Customer creation failed error message',
    defaultMessage: 'Error creating customer',
  },
  customerUpdateFailed: {
    id: 'customerSettings.customer.customerUpdateFailed',
    description: 'Customer update failed error message',
    defaultMessage: 'Error updating customer',
  },

  propertyValueRequired: {
    id: 'customerSettings.customer.propertyValueRequired',
    description: 'Customer value required',
    defaultMessage: 'Customer {propertyName} is required',
  },
  propertyValueMustBeUnique: {
    id: 'customerSettings.customer.propertyValueMustBeUnique',
    description: 'Customer value must be unique',
    defaultMessage: 'Customer {propertyName} must be unique',
  },
  propertyValueMaxLength: {
    id: 'customerSettings.customer.propertyValueMaxLength',
    description: 'Customer value max length',
    defaultMessage: 'Customer {propertyName} must be max {length} characters',
  },

  addNewCustomerModalTitle: {
    id: 'customerSettings.customer.addNewCustomerModalTitle',
    description: 'Customer Settings addNewCustomerModalTitle',
    defaultMessage: 'Add New Customer',
  },
  viewBtn: {
    id: 'customerSettings.customer.viewBtn',
    description: 'Customer Settings viewBtn',
    defaultMessage: 'View',
  },
  editBtn: {
    id: 'customerSettings.customer.editBtn',
    description: 'Customer Settings editBtn',
    defaultMessage: 'Edit',
  },
  deleteBtn: {
    id: 'customerSettings.customer.deleteBtn',
    description: 'Customer Settings deleteBtn',
    defaultMessage: 'Delete',
  },
  customers: {
    id: 'customerSettings.customer.customers',
    description: 'Customer Settings showAllCustomers',
    defaultMessage: 'Customers',
  },
  createEditCustomer: {
    id: 'customerSettings.customer.createEditCustomer',
    description: 'Customer Settings createEditCustomer',
    defaultMessage: 'Create/Edit Customer',
  },
  viewCustomer: {
    id: 'customerSettings.customer.viewCustomer',
    description: 'Customer Settings viewCustomer',
    defaultMessage: 'View Customer',
  },
  newCustomerLbl: {
    id: 'customerSettings.customer.newCustomerLbl',
    description: 'Customer Settings newCustomerLbl',
    defaultMessage: 'New Customer',
  },
  showAllCustomerslbl: {
    id: 'customerSettings.customer.showAllCustomerslbl',
    description: 'Customer Settings showAllCustomerslbl',
    defaultMessage: 'Show All Customers',
  },
  customerDetail: {
    id: 'customerSettings.customer.customerDetail',
    description: 'Customer Detail',
    defaultMessage: 'Customer Detail',
  },
  customerName: {
    id: 'customerSettings.customer.customerName',
    description: 'Customer Name',
    defaultMessage: 'Customer Name',
  },
  accountOwner: {
    id: 'customerSettings.customer.accountOwner',
    description: 'Account Manager',
    defaultMessage: 'Account Manager',
  },
  accountOwnerFirstName: {
    id: 'customerSettings.customer.accountOwnerFirstName',
    description: 'Account Manager First Name',
    defaultMessage: 'Account Manager First Name',
  },
  accountOwnerLastName: {
    id: 'customerSettings.customer.accountOwnerLastName',
    description: 'Account Manager Last Name',
    defaultMessage: 'Account Manager Last Name',
  },
  accountOwnerFirstNameIsRequired: {
    id: 'customerSettings.customer.accountOwnerFirstNameIsRequired',
    description: 'Account Manager First Name is required',
    defaultMessage: 'Account Manager First Name is required',
  },
  accountOwnerIsRequired: {
    id: 'customerSettings.customer.accountOwnerLastNameIsRequired',
    description: 'Account Manager Last Name is required',
    defaultMessage: 'Account Manager is required',
  },
  customerAlias: {
    id: 'customerSettings.customer.customerAlias',
    description: 'Customer Alias',
    defaultMessage: 'Customer Alias',
  },
  customerAccountNumber: {
    id: 'customerSettings.customer.customerAccountNumber',
    description: 'Account Number',
    defaultMessage: 'Account Number',
  },
  customerEmail: {
    id: 'customerSettings.customer.customerEmail',
    description: 'Customer Email',
    defaultMessage: 'Customer Email',
  },
  secondaryEmail: {
    id: 'customerSettings.customer.secondaryEmail',
    description: 'Secondary Email',
    defaultMessage: 'Secondary Email',
  },
  companyRegistrationNumber: {
    id: 'customerSettings.customer.companyRegistrationNumber',
    description: 'Company Registration Number',
    defaultMessage: 'Company Registration Number',
  },
  VATNumber: {
    id: 'customerSettings.customer.VATNumber',
    description: 'VAT Number',
    defaultMessage: 'VAT NUmber',
  },
  industry: {
    id: 'customerSettings.customer.industry',
    description: 'Industry',
    defaultMessage: 'Industry',
  },
  webSite: {
    id: 'customerSettings.customer.webSite',
    description: 'Customer Website',
    defaultMessage: 'Customer Website',
  },

  // E5 (Epic 321) register-customer modal. New "Account Owner" copy (distinct from the legacy
  // "Account Manager" labels above) for the create-customer-under-tenant flow.
  registerCustomerTitle: {
    id: 'customerSettings.customer.registerCustomerTitle',
    description: 'Register customer modal header',
    defaultMessage: 'Register Customer',
  },
  registerCustomerLbl: {
    id: 'customerSettings.customer.registerCustomerLbl',
    description: 'Register customer button',
    defaultMessage: 'Register Customer',
  },
  accountOwnerSectionTitle: {
    id: 'customerSettings.customer.accountOwnerSectionTitle',
    description: 'Account Owner section title',
    defaultMessage: 'Account Owner',
  },
  aoFirstName: {
    id: 'customerSettings.customer.aoFirstName',
    description: 'Account Owner First Name',
    defaultMessage: 'Account Owner First Name',
  },
  aoLastName: {
    id: 'customerSettings.customer.aoLastName',
    description: 'Account Owner Last Name',
    defaultMessage: 'Account Owner Last Name',
  },
  aoEmail: {
    id: 'customerSettings.customer.aoEmail',
    description: 'Account Owner Email',
    defaultMessage: 'Account Owner Email',
  },
  aoPhone: {
    id: 'customerSettings.customer.aoPhone',
    description: 'Account Owner Phone',
    defaultMessage: 'Account Owner Phone',
  },
  aoFirstNameRequired: {
    id: 'customerSettings.customer.aoFirstNameRequired',
    description: 'Account Owner First Name is required',
    defaultMessage: 'Account Owner First Name is required',
  },
  aoLastNameRequired: {
    id: 'customerSettings.customer.aoLastNameRequired',
    description: 'Account Owner Last Name is required',
    defaultMessage: 'Account Owner Last Name is required',
  },
  aoEmailRequired: {
    id: 'customerSettings.customer.aoEmailRequired',
    description: 'Account Owner Email is required',
    defaultMessage: 'Account Owner Email is required',
  },
  aoEmailInvalid: {
    id: 'customerSettings.customer.aoEmailInvalid',
    description: 'Account Owner Email is invalid',
    defaultMessage: 'Enter a valid email address',
  },
  registerCustomerSuccess: {
    id: 'customerSettings.customer.registerCustomerSuccess',
    description: 'Register customer success',
    defaultMessage: 'Customer registered. An invitation has been sent to the Account Owner.',
  },
  // Exact wording mandated by WI 514.
  duplicateEmailInScope: {
    id: 'customerSettings.customer.duplicateEmailInScope',
    description: 'Duplicate Account Owner email (409 DUPLICATE_EMAIL_IN_SCOPE)',
    defaultMessage:
      'A user with this email already exists for this Tenant. Try a different email or contact support.',
  },
})

export default messages
